define('modules/targeting/pixel/views/readOnly',["Underscore", "T1", "T1View", "text!../templates/readOnly.html", "utils/CampaignStrategyUtils"], function (_, T1, T1View, template, Utils) {
  "use strict";

  var readOnlyView = T1View.extend({
    template: template,
    loaderOpts: {
      target: ".view-loader",
      text: "loading...",
      contentClass: "loader"
    },
    initialize: function ({
      model: model,
      editLinkPrefix: editLinkPrefix,
      canEdit: canEdit
    }) {
      this.strategy = model;
      this.canLoad = false;
      this.editLinkPrefix = editLinkPrefix;
      this.canEdit = Boolean(canEdit);
      this.pixelTitle = {
        DATA: "DATA PIXELS",
        EVENT: "EVENT PIXELS",
        DYNAMIC: "ADAPTIVE SEGMENTS"
      };
      this.strategy.fetchPixelTargets(data => {
        this.canLoad = true;
        this.collection = data;
        this.load();
      }, false);
    },
    load: function () {
      this.render().then(() => {
        const loader = this.loader();
        if (!this.canLoad || this.canLoad === false) {
          loader.start();
        } else {
          loader.stop();
          this.$(".loader-holder").hide();
          if (!this.hasData) {
            this.$(".section-heading").css({
              opacity: .5
            });
            this.$(".no-selection").css({
              display: "inline-block"
            });
          }
        }
      });
    },
    serialize: function () {
      const collObj = this.collection;
      var resultJSON = {
        dataMain: []
      };
      var groupedDataHashInclude = {
        DATA: {},
        EVENT: {},
        SEGMENT: {},
        CREATIVE: {},
        INVALID: {},
        DYNAMIC: {}
      };
      var groupedDataHashExclude = {
        DATA: {},
        EVENT: {},
        SEGMENT: {},
        CREATIVE: {},
        INVALID: {},
        DYNAMIC: {}
      };
      var formatNumber = T1.Formats.rolledUpNumbersShort();
      var createDataBlock = Utils.createGroupedDataArray;
      var hasData = false;
      var getGroupNameFromModel = Utils.getGroupNameFromPixelModel;
      var getLoadCountFromModel = function (model, key) {
        const report = model.get("unique");
        if (report) {
          return formatNumber(parseInt(report[key], 10));
        }
        return "--";
      };
      var getAndOrOperation = function () {
        var defaultVal = "or";
        var result = defaultVal;
        if (collObj) {
          result = collObj.includeOperator;
          if (!result) {
            result = defaultVal;
          }
        }
        return `(${result})`;
      };
      var includedHeaderAdded = false;
      var excludedHeaderAdded = false;
      function populateHashes(model) {
        const key = this;
        const {
          name: name,
          id: id,
          pixel_type: pixel_type,
          action: action
        } = model.toJSON();
        const type = pixel_type ? pixel_type.toUpperCase() : "INVALID";
        const hashDataSet = action === "include" ? groupedDataHashInclude[type] : groupedDataHashExclude[type];
        if (!hashDataSet[key]) {
          hashDataSet[key] = [];
        }
        if (pixel_type === "dynamic") {
          hashDataSet[key].push({
            name: name,
            load_count: "N/A",
            pixel_id: id
          });
        } else {
          hashDataSet[key].push({
            name: name,
            load_count: getLoadCountFromModel(model, "loads"),
            unique_count: getLoadCountFromModel(model, "uniques"),
            pixel_id: id
          });
        }
      }
      function populateTitles(mode, hash) {
        Object.keys(hash).forEach(key => {
          const tempData = createDataBlock(hash[key]);
          const title = this.pixelTitle[key] || key;
          if (tempData.length) {
            hasData = true;
            if (mode === "include") {
              if (!includedHeaderAdded) {
                includedHeaderAdded = true;
                resultJSON.dataMain.push({
                  sideTitle: `included data<br/>${getAndOrOperation()}`,
                  data: false
                });
              }
            } else {
              if (!excludedHeaderAdded) {
                excludedHeaderAdded = true;
                resultJSON.dataMain.push({
                  sideTitle: "excluded data",
                  data: false
                });
              }
            }
            resultJSON.dataMain.push({
              sideTitle: title,
              data: tempData
            });
          }
        });
      }
      if (this.canEdit) {
        resultJSON.editLink = `${this.editLinkPrefix}/targeting/myData`;
      }
      if (!collObj || !collObj.models || !collObj.models.length) {
        this.hasData = false;
        return resultJSON;
      }
      const groupedCollObj = _.groupBy(collObj.models, model => getGroupNameFromModel(model));
      Object.entries(groupedCollObj).forEach(([key, modelArr]) => {
        modelArr.forEach(populateHashes, key);
      });
      populateTitles.call(this, "include", groupedDataHashInclude);
      populateTitles.call(this, "exclude", groupedDataHashExclude);
      this.hasData = resultJSON.hasData = hasData;
      if (resultJSON.hasData) {
        resultJSON.firstSideTitle = resultJSON.dataMain[0].sideTitle;
        resultJSON.dataMain[0].sideTitle = "";
      }
      return resultJSON;
    }
  });
  return readOnlyView;
});
